module.exports = __webpack_public_path__ + "static/media/icon-header-home.f9de066d.svg";